export default __webpack_public_path__ + "static/media/pic16.ee2b933d.jpg";